<template>
    <div id="app">
        <b-container>
            <router-view/>
        </b-container>
    </div>
</template>

<script>
    import auth from '../../services/auth';

    export default {
        name: 'authenticated-app',
        mounted() {
            auth.init();
            if (this.$store.state.socket.isConnected && this.$store.state.socket.type !== 'client') {
                console.log('Socket: Setting type as client (via mount).');
                console.log('Token', localStorage.getItem('id_token'));
                this.$socket.sendObj({cmd: 'handshake', data: {type: 'client'}, identity: this.$store.state.socket.type});
                this.$store.commit('setSocketType', 'client');

            }
        },
        computed: {
            identity: function () {
                return this.$store.state.socket.identity;
            }
        },
        watch: {
            identity(identity) {
                console.log('Socket: Setting type as client (via watch).');
                this.$socket.sendObj({cmd: 'handshake', data: {type: 'client', token: localStorage.getItem('id_token')}, identity: identity});
                this.$store.commit('setSocketType', 'client');
            }
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/app/app.vue